<template>
  <div v-cloak>
    <div v-if="noData =='false'">
      <!-- 签名弹出层 -->
      <div v-show="test" class="sign" style="position:fixed;top:0;z-index:9999;bottom:0">
        <signature @saveImg="complete"></signature>
      </div>
      <!-- 签名弹出层结束 -->
      <!-- 详情数据 -->
      <detailsCom :id="voteId" :type="type"></detailsCom>
      <!-- 详情数据结束 -->
      <!-- 我的意见 -->
      <div v-if="forTheFirstTime == 0">
        <div class="vore-radio-box">
          <div class="radio-name">我的表决</div>
          <!-- 审批盒子  -->
          <div class="radio-item-box">
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio name="1" checked-color="#29BEBC">同意</van-radio>
              <van-radio name="2" checked-color="#29BEBC">不同意</van-radio>
              <van-radio name="0" checked-color="#29BEBC">弃权</van-radio>
            </van-radio-group>
          </div>
          <!--审批盒子结束  -->
        </div>
        <!-- 签名 -->
        <div v-if="imgData && isSignature==1" class="resign">
          <div class="sign_title">我的签名</div>
          <div style="width:50px;margin-left:30%">
            <img class="sign-img" :src="imgData" />
          </div>
          <span @click="showPopup" class="resign-txt">重新签名</span>
        </div>
        <div v-else-if="!imgData && isSignature==1" @click="showPopup" class="sign-box">
          <p class="sign-p1">本人签名</p>
          <el-button class="sign-btn">
            <span class="img"></span>签名
          </el-button>
        </div>
        <!-- 签名结束 -->
        <div class="sign-btn-box">
          <van-button @click="submit" color="#29BEBC" type="primary" block>提交</van-button>
        </div>
      </div>
      <!-- 我的意见结束 -->
      <!-- 展示详情 -->
      <div v-else>
        <div class="suggest-box vote-bottom-box">
          <p class="suggest-p2">我的表决</p>
          <p class="suggest-p3">{{nameTitle}}</p>
        </div>
        <div class="suggest-box suggest-own">
          <p class="suggest-p2">本人签名</p>
          <div class="img-right">
            <img v-if="resultImgUrl" class="sign-img-icon" :src="resultImgUrl" />
          </div>
        </div>
      </div>
      <!-- 展示详情结束 -->
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>

<script>
import detailsCom from "./details";
import signature from "../../../components/signature.vue";
import { toast } from "@/common/api/api.js";
import pageNone from "../../../components/pageNone";
export default {
  data() {
    return {
      nameTitle: "",
      nameTitleConfig: {
        "0": "弃权",
        "1": "同意",
        "2": "不同意"
      },
      isSignature: "",
      forTheFirstTime: "",
      imgData: "", //签名
      resultImgUrl: "",
      test: false,
      radio: "1", //意见盒子
      id: "",
      type: "",
      voteId: this.$route.query.voteId,
      noData: "",
    };
  },
  components: {
    detailsCom,
    signature,
    pageNone
  },
  created() {
    this.getDetails(); //0弃权  1同意  2不通
  },
  methods: {
    //处理返回数据
    getDetailsFun(data, message) {
      this.isSignature = data.vote.isSignature;
      this.forTheFirstTime = data.record.statusp;
      this.type = data.vote.type;
      this.id = data.record.id;
      if (this.forTheFirstTime != 0) {
        this.resultImgUrl = data.record.signatrue;
        this.nameTitle = this.nameTitleConfig[data.record.resultp];
      }
    },
    //获取详情参数
    getgetDetailsData() {
      var obj = {
        id: this.voteId
      };
      return obj;
    },
    //获取详情数据
    getDetails() {
      var obj = this.getgetDetailsData();
      this.sendQuestion("wechatRepreDetail", obj, "getDetailsFun");
    },
    //获取提价参数
    getSubmitData() {
      var obj = {
        voteId: this.voteId,
        id: this.id,
        resultp: this.radio,
        signatrue: this.imgData
      };
      return obj;
    },
    //提交成功
    submitFun(data, message) {
      toast(this, message, "success");
      this.$router.go(-1);
    },
    //提交函数
    submit() {
      if (this.isSignature == 1 && (!this.imgData || this.imgData == "")) {
        toast(this, "签名不能为空!", "error");
        return;
      }
      var obj = this.getSubmitData();
      this.sendQuestion("subDemoraticVoteRecord", obj, "submitFun");
    },
    complete(data) {
      this.imgData = data;
      this.test = false;
    },
    closePop() {
      this.test = false;
    },
    showPopup() {
      this.test = !this.test;
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        res => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this.noData = "false";
            this[fun](data, message);
          } else {
            this.noData = "true";
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    }
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/common.styl';
  [v-cloak]{
            display: none;
  }
.vote-bottom-box {
  display: flex;
  align-items: center;

  .suggest-p3 {
    margin-top: 0;
    flex: 1;
    text-align: right;
  }

  .name-icon {
    width: 23px;
    height: 23px;
    margin-right: 5px;
  }
}

.resign {
  padding: 10px 0px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin: 0 15px;

  .sign-img {
    width: 60px;
    height: 60px;
    margin: auto;
  }

  .resign-txt {
    color: $default-color;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    font-style: normal;
  }
}

.vore-radio-box {
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 15px 15px;

  .radio-name {
    stepTextStyle();
    color: $text-black;
  }

  .radio-item-box {
    margin-top: 15px;

    >>>.van-radio-group {
      justify-content: center;
    }

    >>>.van-radio--horizontal {
      margin: auto;
    }
  }
}

.vote-info-box {
  background: #fff;
  margin: 10px auto;
  padding: 15px;
  display: flex;

  .info-p1 {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: $text-black;
  }

  .info-p1:before {
    content: '';
    display: inline-block;
    width: 7px;
    height: 7px;
    background: $main-bgColor;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.sign-btn {
  width: 100%;
  color: #38c7c4;
  border-color: $default-color;
  background-color: #fff;

  .img {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url('/img/icon-sign.00caefc8.png') no-repeat center center;
    background-size: 100% 100%;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.resign-txt {
  color: $default-color;
  font-size: 12px;
  font-style: italic;
  display: inline-block;
  text-align: center;
}

.resign {
  flex: 1;
}
</style>